import { JSEncrypt } from 'jsencrypt';
import { stringify } from 'qs';
import {
    postLoginSocialIndividualApi,
    postLoginSocialIndividualPasswordApi,
    getPublicKeyApi,
    postTenantSelectInfosApi,
    linkedInCheckPasswordApi,
} from '../apis/sign-up';
import { getFreeRegisterUrlParams } from './get-register-url-params';
import { getRedirectUri } from './iframe-compat';
import type { PostTenantSelectInfosParams } from '../types/tenant';
import { map } from 'lodash-es'
import type { Channels } from '../../..';

export function getParamsUrl() {
    const EUREKA_CLIENT_NAME = import.meta.env.VITE_PASSPORT_CLIENT_NAME
    const EUREKA_CLIENT_ID = import.meta.env.VITE_PASSPORT_CLIENT_ID
    const queryStr = stringify({
        from: EUREKA_CLIENT_NAME,
        redirect_uri: getRedirectUri(),
        client_id: EUREKA_CLIENT_ID,
        ...getFreeRegisterUrlParams(),
    });
    return queryStr;
}

export async function postLoginSocialIndividual(data: { credential: string }, channels?: Channels) {
    const { token } = await postLoginSocialIndividualApi('google', {
        id_token: data.credential,
        ...channels,
        ...getFreeRegisterUrlParams(),
    });
    return token;
}

export async function postLoginSocialIndividualPassword(data: {
    password: string;
    credential: string;
}) {
    const { password, credential } = data;
    const publicKey = await getPublicKeyApi();
    const encrypt = new JSEncrypt({});
    encrypt.setPublicKey(publicKey);
    const encryptPwd = encrypt.encrypt(password);

    const registerParams = getFreeRegisterUrlParams();

    const { token } = await postLoginSocialIndividualPasswordApi('google', {
        id_token: credential,
        password: encryptPwd,
        ...registerParams,
    });

    return token;
}

export async function linkedInCheckPassword(data: {
    email: string;
    password: string;
}) {
    const { password } = data;
    const publicKey = await getPublicKeyApi();
    const encrypt = new JSEncrypt({});
    encrypt.setPublicKey(publicKey);
    const encryptPwd = encrypt.encrypt(password);
    await linkedInCheckPasswordApi({
        ...data,
        password: encryptPwd as string,
        source: 'linkedin',
        from: 'eureka',
    });
}

export async function microsoftCheckPassword(data: {
    email: string;
    password: string;
}) {
    const { password } = data;
    const publicKey = await getPublicKeyApi();
    const encrypt = new JSEncrypt({});
    encrypt.setPublicKey(publicKey);
    const encryptPwd = encrypt.encrypt(password);
    await linkedInCheckPasswordApi({
        ...data,
        password: encryptPwd as string,
        source: 'microsoft',
        from: 'eureka',
    });
}

/** 获取租户列表 */
export async function getTenant(params: PostTenantSelectInfosParams) {
    let tenants = await postTenantSelectInfosApi(params);
    tenants = map(tenants, (item) => {
        if (item.individual) {
            item.tenant_name = 'Sign in as an individual';
        }
        return item;
    });
    return tenants;
}
